import StarOutlineRounded from "@mui/icons-material/StarOutlineRounded";
import React from "react";
import { useHistory } from "react-router-dom";
import { useGlobalLinks } from "../../../../services/app-state";
import { getAcfPostUrl } from "../../../../utils";
import { Outer, Header, Title, Copy, IconCircle } from "./styled";

export const Skeleton = () => {
    const history = useHistory();
    const [, { getGlobalLink }] = useGlobalLinks();

    return (
        <Outer
            onClick={() => {
                history.push(getAcfPostUrl(getGlobalLink("local_services_page")));
            }}
        >
            <Header>
                <IconCircle>
                    <StarOutlineRounded fontSize="large" />
                </IconCircle>
                <Title>You currently have no saved resources.</Title>
            </Header>

            <Copy>
                When navigating Headstart look for the <strong>star</strong> to save that page or
                service. You can then access your saved resources anytime by visiting this page.
            </Copy>

        </Outer>
    );
};
